const openFilterEls = document.querySelectorAll('[data-open-filters]')
const sidebar = document.querySelector('.sidebar')

const openFilters = () => {
    document.body.classList.add('sidebar-is-open')
    document.querySelector('.sidebar__close').focus()
    document.addEventListener('keyup', (event) => {
        if(event.key === "Escape") {
            closeFilters()
        }
    })
}

const closeFilters = () => {
    document.body.classList.remove('sidebar-is-open')
}

document.addEventListener('click', (event) => {
    if(event.target.closest('[data-open-filters]')) {
        event.preventDefault()
        openFilters()
    }
})

document.addEventListener('click', (event) => {
    if(event.target.closest('.sidebar__close')) {
        closeFilters()
    }
})

export {openFilters, closeFilters}
